import axios, { AxiosInstance } from "axios";
import store from "@/store";
import { ModuleTypes } from "@/store/ModuleTypes";
import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";
import jwt from "jsonwebtoken";
import { isDateBefore } from "@/helpers/date.utils";
import { Routes } from "@/router/Routes";
import MutationTypes from "@/store/MutationTypes";

const BACKEND_URL = process.env.VUE_APP_GATEWAY_URL
  ? `${process.env.VUE_APP_GATEWAY_URL}/rest-api/`
  : "/rest-api/";
// : "https://teambot-test.snlb.pl/rest-api/";

const TEAMBOT_BACKEND_URL = process.env.VUE_APP_GATEWAY_URL || "";

export const apiClient = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000
});

export const api: AxiosInstance = axios.create({
  baseURL: `${TEAMBOT_BACKEND_URL}`
});

// apiV1Client.interceptors.response.use(
//   response => {
//     return response;
//   },
//   error => {
//     if (error.response.status === 401 || error.response.status === 403) {
//       fetch("/rest-api/users/profile").then((response: any) => {
//         if (response.status && response.status === 403) {
//           window.location.href = `/logout`;
//         }
//       });
//       return Promise.reject(error);
//     }
//   }
// );

apiClient.interceptors.response.use(
  (response: any) => response,
  (error: { response: any }) => {
    if (typeof error.response === "undefined") {
      store.dispatch(
        `${ModuleTypes.SNACKBAR}/${SnackbarMutationTypes.SHOW_SNACKBAR}`,
        error
      );
    }
    return Promise.reject(error);
  }
);

apiClient.interceptors.request.use((req: any) => {
  const authToken = store.getters?.["auth/token"];
  const isAuthTokenLoaded = store.getters?.["auth/isAuthTokenLoaded"];
  if (!process.env.VUE_APP_IS_LOCAL_ENVIRONMENT && isAuthTokenLoaded) {
    const decodedAuthToken: any = jwt.decode(authToken);
    const tokenExpInSeconds = decodedAuthToken?.exp;
    if (
      !decodedAuthToken ||
      (tokenExpInSeconds && isDateBefore(tokenExpInSeconds * 1000, new Date()))
    ) {
      store.dispatch("auth/logout", null, { root: true });
    }

    return req;
  }
  return req;
});
